import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Yıldırım Mahallesi Halı Yıkama",
    path: "/bayrampasa/yildirim-hali-yikama",
    description:
      "Yıldırım Mahallesi’nde halılarınız antibakteriyel temizlik ürünleriyle özenle yıkanır, hızlı şekilde teslim edilir."
  },
  {
    label: "Kartaltepe Mahallesi Halı Yıkama",
    path: "/bayrampasa/kartaltepe-hali-yikama",
    description:
      "Kartaltepe Mahallesi’nde bireysel ve kurumsal müşterilere özel hijyenik halı yıkama hizmeti sunmaktayız."
  },
  {
    label: "Kocatepe Mahallesi Halı Yıkama",
    path: "/bayrampasa/kocatepe-hali-yikama",
    description:
      "Kocatepe Mahallesi’nde tam otomatik sistemlerle halı temizliği yapılır, kapıdan alım ve teslim ücretsizdir."
  },
  {
    label: "Altıntepsi Mahallesi Halı Yıkama",
    path: "/bayrampasa/altintepsi-hali-yikama",
    description:
      "Altıntepsi Mahallesi’nde halılarınızı el değmeden, modern makinelerde derinlemesine temizliyoruz."
  },
  {
    label: "Terazidere Mahallesi Halı Yıkama",
    path: "/bayrampasa/terazidere-hali-yikama",
    description:
      "Terazidere bölgesine özel servisimizle halılarınız kısa sürede hijyenik olarak temizlenip teslim edilir."
  },
  {
    label: "Cevatpaşa Mahallesi Halı Yıkama",
    path: "/bayrampasa/cevatpasa-hali-yikama",
    description:
      "Cevatpaşa Mahallesi’nde organik temizlik ürünleri ile sağlıklı ve güvenilir halı yıkama sağlıyoruz."
  },
  {
    label: "Muratpaşa Mahallesi Halı Yıkama",
    path: "/bayrampasa/muratpasa-hali-yikama",
    description:
      "Muratpaşa Mahallesi’nde halı yıkama hizmetimiz profesyonel kadro ve kaliteli malzeme garantisiyle sunulur."
  }
];

const BayrampasaSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">BAYRAMPAŞA SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BayrampasaSidebar;
